import {displayModes} from '../../../services/enums/displayModes';
import Columns from './columns';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 1,
    columns: {}
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {
      tourId: {
        columnName: Columns.tourId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      microHub: {
        columnName: Columns.microHub.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      numStops: {
        columnName: Columns.numStops.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      storagePlace: {
        columnName: Columns.storagePlace.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4
      },
      duration: {
        columnName: Columns.duration.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      driver: {
        columnName: Columns.driver.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      vehicle: {
        columnName: Columns.vehicle.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 7
      },
      planedTourDelivery: {
        columnName: Columns.planedTourDelivery.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 8
      },
      approved: {
        columnName: Columns.approved.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 9
      },
    }
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {}
  },
}

export default DefaultConfig;